import type * as React from 'react';

import { DeveloperPlainCodeBlock } from './DeveloperTools';

/** Compact prompt preview using the same code block treatment as developer setup snippets. */
export function PromptBox(props: { prompt: string; onCopy?: () => void }): React.ReactElement {
    return (
        <DeveloperPlainCodeBlock
            code={props.prompt}
            syntax="markdown"
            showLineNumbers={false}
            expandable
            collapsedLineCount={3}
            copyLabel="Copy AI prompt"
            copyIconOnly={false}
            onCopy={props.onCopy}
        />
    );
}
